import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  /** `plain` sits on the ground; `raised` is a lifted surface; `accent` carries the argument; `ink` is the featured panel. */
  variant?: 'plain' | 'raised' | 'accent' | 'ink';
  className?: string;
}

export function Card({ children, variant = 'plain', className }: CardProps) {
  return (
    <div
      className={cn(
        'rounded-sm border',
        variant === 'plain' && 'bg-paper-2 border-line',
        variant === 'raised' && 'bg-surface border-line',
        variant === 'accent' && 'bg-surface border-accent/30 border-l-[3px] border-l-accent',
        variant === 'ink' && 'bg-surface-2 text-ink border-line-strong border-t-2 border-t-accent',
        className
      )}
    >
      {children}
    </div>
  );
}
